/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
// Dependencies
import React from "react";
import { LinkedIn, Facebook, Instagram } from "@material-ui/icons";

import {
  FooterWrapper,
  ContentWrapper,
  IconContainer,
} from "../styling/FooterStyling";

// FOOTER ------------------------------------------
export const Footer = () => {
  return (
    <FooterWrapper>
      <ContentWrapper>
        <a href="mailto:hello@weexist.se">
          <h3 tabIndex="0">hello@weexist.se</h3>
        </a>
        <p>Stockholm, Sweden</p>
        <IconContainer>
          <a
            href="https://www.linkedin.com/company/we-exist-recruitment/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <LinkedIn className="icon" />
          </a>
          <a
            href="https://www.instagram.com/weexist_recruitment/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Instagram className="icon" />
          </a>
          <a
            href="https://www.facebook.com/weexistrecruitment/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Facebook className="icon" />
          </a>
        </IconContainer>
      </ContentWrapper>
    </FooterWrapper>
  );
};
